import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sectionIdFromPathname } from "@/constants/homeSections";

/**
 * Scroll to top on route change. Home section paths (/pricing, etc.) handle their own scroll.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const homeSection = sectionIdFromPathname(pathname);
    if (homeSection || hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
